<div
  class="bg-black-200 animate-pulse"
  [ngStyle]="{ width: skeletonWidth, height: skeletonHeight, 'border-radius': skeletonBorder }"
></div>
